import React from 'react';
import { Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

interface AlignmentBadgeProps {
  alignment: number; // 0-1
}

const getAlignmentLabel = (alignment: number) => {
  if (alignment >= 0.7) return 'Bien aligné';
  if (alignment >= 0.4) return 'Partiellement aligné';
  return 'Mal aligné';
};

const getAlignmentColor = (alignment: number) => {
  if (alignment >= 0.7) return 'success';
  if (alignment >= 0.4) return 'warning';
  return 'error';
};

const AlignmentBadge: React.FC<AlignmentBadgeProps> = ({ alignment }) => (
  <Chip
    icon={alignment >= 0.7 ? <CheckCircleIcon /> : <ErrorOutlineIcon />}
    label={getAlignmentLabel(alignment)}
    color={getAlignmentColor(alignment) as any}
    variant="outlined"
    sx={{ fontWeight: 'bold', mb: 2 }}
  />
);

export default AlignmentBadge;
